document.addEventListener('DOMContentLoaded', function () {
  function findCheckoutButton() {
    return document.querySelector(
      'form[action="/checkout"] [type="submit"], button[name="checkout"], .cart__checkout-button'
    );
  }

  function waitForDisclaimer() {
    if (!document.querySelector('.edc_tacbox')) {
      setTimeout(waitForDisclaimer, 200);
      return;
    }
    initCartDisclaimer();
  }

  function initCartDisclaimer() {
    const disclaimerBox = document.querySelector('.edc_tacbox');
    const checkbox     = document.querySelector('#edc_agree');
    const notice       = document.querySelector('#edc_agree-notice');

    const expressSelectors = [
      '.shopify-payment-button',
      '.additional-checkout-buttons',
      '.dynamic-checkout__content',
      '.cart__dynamic-checkout-buttons',
      '[data-shopify-buttoncontainer]'
    ];

    function getExpressContainers() {
      return document.querySelectorAll(expressSelectors.join(','));
    }

    function disableButtons() {
      const btn = findCheckoutButton();
      if (btn) {
        btn.removeAttribute('disabled');
        btn.classList.add('edc-disabled');
      }
      getExpressContainers().forEach(c => {
        c.style.display = 'none';
        c.style.visibility = 'hidden';
      });
      console.log('DEBUG: Buttons DISABLED');
    }

    function enableButtons() {
      const btn = findCheckoutButton();
      if (btn) {
        btn.classList.remove('edc-disabled');
      }
      getExpressContainers().forEach(c => {
        c.style.display = '';
        c.style.visibility = '';
      });
      console.log('DEBUG: Buttons ENABLED');
    }

    function getBuuntoMode() {
      const labels = document.querySelectorAll('.buunto-method-picker label');
      if (!labels.length) return null;
      for (let i = 0; i < labels.length; i++) {
        if (labels[i].classList.contains('selected')) {
          if (i === 0) return 'delivery';
          if (i === 1) return 'local';
          if (i === 2) return 'pickup';
        }
      }
      return null;
    }

    function validateState() {
      // 1) Ermitteln, ob cooling‑Tags da sind
      const lineItems = document.querySelectorAll('cart-item.cart-item');
      let needsCooling   = false;
      let hasExpressOnly = false;
      let boutiqueOnly   = false;

      lineItems.forEach(el => {
        const tags = (el.dataset.tags || '')
          .split(',')
          .map(t => t.trim().toLowerCase());
        if (tags.includes('kuehlung-im-sommer-erforderlich')) needsCooling = true;
        if (tags.includes('buunto-expressversand-wunschdatum'))  hasExpressOnly = true;
        if (tags.includes('buunto-boutique-only-abholung'))     boutiqueOnly = true;
      });

      const buuntoMode = getBuuntoMode();
      const btn = findCheckoutButton();
      console.log(
        `DEBUG: needsCooling=${needsCooling}, ` +
        `expressOnly=${hasExpressOnly}, boutiqueOnly=${boutiqueOnly}, ` +
        `buuntoMode=${buuntoMode}, checkbox=${checkbox.checked}`
      );

      // 2) Wenn gar kein cooling-Produkt im Warenkorb → Disclaimer verstecken
      if (!needsCooling) {
        disclaimerBox.style.display = 'none';
        enableButtons();
        return;
      }

      // 3) cooling-Produkt ist da → Disclaimer einblenden
      disclaimerBox.style.display = 'block';

      // express-only oder boutique-only ignorieren Disclaimer
      if (hasExpressOnly || boutiqueOnly) {
        disclaimerBox.style.display = 'none';
        enableButtons();
        return;
      }

      // Buunto‑Pickup/Local überspringt Disclaimer
      if (buuntoMode === 'pickup' || buuntoMode === 'local') {
        disclaimerBox.style.display = 'none';
        enableButtons();
        return;
      }

      // 4) Checkbox-Logik
      if (checkbox.checked) {
        enableButtons();
        notice.style.display = 'none';
      } else {
        disableButtons();
      }
    }

    checkbox?.addEventListener('change', validateState);

    // MutationObserver jetzt nur noch für Button‑State nötig
    const cartContainer = document.querySelector(
      'form[action="/cart"], .cart-items, #CartContainer'
    );
    if (cartContainer) {
      const observer = new MutationObserver(() => {
        setTimeout(validateState, 100);
      });
      observer.observe(cartContainer, { childList: true, subtree: true });
    } else {
      console.warn(
        'cart-disclaimer.js: Kein Cart-Container gefunden – MutationObserver übersprungen.'
      );
    }

    setInterval(validateState, 500);
    validateState();

    // Scroll + Hinweis bei Klick auf edc‑disabled Button
    document.addEventListener('click', function (e) {
      const btn = findCheckoutButton();
      if (!btn) return;
      if (btn.classList.contains('edc-disabled') && btn.contains(e.target)) {
        console.log('✅ Scroll + Hinweis triggered!');
        const y = disclaimerBox.getBoundingClientRect().top + window.scrollY - 50;
        window.scrollTo({ top: y, behavior: 'smooth' });
        notice.style.display = 'block';
        e.preventDefault();
      }
    });
  }

  waitForDisclaimer();
});
// -------------------------
// Disclaimer 2: Adventskalender
// -------------------------
document.addEventListener('DOMContentLoaded', function () {
  function waitForDisclaimer2() {
    if (!document.querySelector('#edc_adv')) {
      setTimeout(waitForDisclaimer2, 200);
      return;
    }
    initCartDisclaimer2();
  }

  function initCartDisclaimer2() {
    const advBox = document.querySelector('#edc_adv');
    if (!advBox) return;

    function getLineItems() {
      return document.querySelectorAll('cart-item.cart-item');
    }

    function cartHasAdvTag() {
      const items = getLineItems();
      const TRIGGER = 'buunto-versand-oder-abholung-nov14';
      let found = false;
      items.forEach(el => {
        const tags = (el.dataset.tags || '')
          .split(',')
          .map(t => t.trim().toLowerCase())
          .filter(Boolean);
        if (tags.includes(TRIGGER)) found = true;
      });
      return found;
    }

    function validateState2() {
      const hasAdv = cartHasAdvTag();
      advBox.style.display = hasAdv ? 'block' : 'none';
      console.log(`ADV2 DEBUG: tagPresent=${hasAdv}`);
    }

    const cartContainer = document.querySelector(
      'form[action="/cart"], .cart-items, #CartContainer'
    );
    if (cartContainer) {
      const observer = new MutationObserver(() => {
        setTimeout(validateState2, 100);
      });
      observer.observe(cartContainer, { childList: true, subtree: true });
    } else {
      console.warn('adv2.js: Kein Cart-Container gefunden – MutationObserver übersprungen.');
    }

    setInterval(validateState2, 500);
    validateState2();
  }

  waitForDisclaimer2();
});

// -------------------------
// Case-Mix Guard: Adventskalender × Macarons → getrennt bestellen
// -------------------------
document.addEventListener('DOMContentLoaded', function () {
  // Tags (kleingeschrieben, weil wir im DOM lowercasing nutzen)
  const TAG_CASE2 = 'buunto-expressversand-wunschdatum';   // Macarons
  const TAG_CASEX = 'buunto-versand-oder-abholung-nov14';  // Advent

  // Hilfen (eigenständig, keine Abhängigkeit zu anderen Blöcken)
  function findCheckoutButton() {
    return document.querySelector(
      'form[action="/checkout"] [type="submit"], button[name="checkout"], .cart__checkout-button'
    );
  }
  function getExpressContainers() {
    return document.querySelectorAll(
      '.shopify-payment-button, .additional-checkout-buttons, .dynamic-checkout__content, .cart__dynamic-checkout-buttons, [data-shopify-buttoncontainer]'
    );
  }
  function cartHas(tag) {
    return Array.from(document.querySelectorAll('cart-item.cart-item'))
      .some(el => (el.dataset.tags || '')
        .toLowerCase()
        .split(',')
        .map(s => s.trim())
        .includes(tag));
  }

  const splitBox = document.getElementById('edc_split');

  function setCheckoutDisabled(disabled) {
    const btn = findCheckoutButton();
    if (btn) {
      if (disabled) {
        btn.classList.add('edc-disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.style.opacity = '0.6';
      } else {
        btn.classList.remove('edc-disabled');
        btn.removeAttribute('aria-disabled');
        btn.style.opacity = '';
      }
    }
    getExpressContainers().forEach(c => {
      c.style.display = disabled ? 'none' : '';
      c.style.visibility = disabled ? 'hidden' : '';
    });
  }

  function updateSplitState() {
    const mixed = cartHas(TAG_CASE2) && cartHas(TAG_CASEX);
    if (!splitBox) return;

    if (mixed) {
      splitBox.style.display = 'block';
      setCheckoutDisabled(true);
    } else {
      splitBox.style.display = 'none';
      setCheckoutDisabled(false);
    }
  }

    // Klick-Guard: bei blockiertem Checkout nur scrollen + highlighten (kein alert)
  document.addEventListener('click', function (e) {
    const btn = findCheckoutButton();
    if (!btn) return;
    if (btn.classList.contains('edc-disabled') && btn.contains(e.target)) {
      e.preventDefault();
      const y = splitBox.getBoundingClientRect().top + window.scrollY - 60;
      window.scrollTo({ top: y, behavior: 'smooth' });
      // kurz highlighten
      splitBox.style.outline = '2px solid #f0c200';
      setTimeout(() => (splitBox.style.outline = ''), 1200);
    }
  }, { capture: true });


  // Initial + bei Cart‑Updates (dein Theme triggert cart:refresh bereits)
  updateSplitState();
  document.addEventListener('cart:refresh', () => setTimeout(updateSplitState, 80));
  setInterval(updateSplitState, 800); // sanfte Absicherung
});
